import React from "react";
import DialogInOne from "../../../components/DialogInOne";
import { useTranslation } from "../../../hooks";

interface IProps {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  content: React.ReactNode;
  onConfirm: () => void;
}

const RentDialog = (props: IProps) => {
  const { isOpen, onClose, title, content, onConfirm } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  const dialogConfig = {
    title: title || t("rent_resource"),
    self: {
      open: isOpen,
      onClose: onClose,
    },
    content: content,
    onCancel: onClose,
    onConfirm: onConfirm,
  };

  return <DialogInOne {...dialogConfig} maxWidth="lg" />;
};

export default RentDialog;
